export enum TIPO_AFILIACION {
  ORIGINAL = "ORIGINAL",
  ALTERNA = "ALTERNA"
}

export enum TIPO_SERVICIO_AFILIACION {
  CARGO_AUTOMATICO_TDC = "CARGO_AUTOMATICO_TDC",
  CARGO_AUTOMATICO_AMEX = "CARGO_AUTOMATICO_AMEX",
  LINEA_PAGO_TDC = "LINEA_PAGO_TDC",
  LINEA_PAGO_AMEX = "LINEA_PAGO_AMEX",
  CARGO_DIRECTO_TDC = "CARGO_DIRECTO_TDC",
  CARGO_DIRECTO_AMEX = "CARGO_DIRECTO_AMEX",
  APP = "APP"
}

export interface AFILIACION {
  idClub: number;
  idAfiliacion: number;
  afiliacion: String;
  tipoAfiliacion: TIPO_AFILIACION;
  servicio: TIPO_SERVICIO_AFILIACION;
  idSucursal: String;
  idBuzon: String;
}

export interface Props {
  userContext: { clubSessionId: any };
}

export interface State {
  onSearch: boolean;
  clubs: {
    clubId: number;
    nombre: string;
    claveCorta: string;
  }[];

  modalAfiliacionesIsOpen: boolean;

  selectedClubId: number;
  selectedClubkey: String;
  selectedClubName: String;
  selectedClubAfCatOrigVisaMc: AFILIACION;
  selectedClubAfCatAltVisaMc: AFILIACION;
  selectedClubAfCatOrigAmex: AFILIACION;
  selectedClubAfCdOrigVisaMc: AFILIACION;
  selectedClubAfCdOrigAmex: AFILIACION;
}
